<!--
 * @Author       : zxlin
 * @Date         : 2024-03-14 17:25:56
 * @LastEditors  : zxlin
 * @LastEditTime : 2024-03-21 13:47:01
 * @FilePath     : \calendar-singapore\src\layout\pc\components\FooterComponent.vue
 * @Description  :
-->
<template>
  <div class="footer">
    <div class="footer_context">
      <div class="left">
        <div>
          <div>
            {{ $t('address') }}60 PAYA LEBAR ROAD #04-10 PAYA LEBAR SQUARE
            SINGAPORE 409051
          </div>
          <div class="border">
            <img :src="require('@/assets/imgs/adress_icon.png')" />
          </div>
        </div>
        <div>{{ $t('email') }}hr@youloft.com</div>
        <div>{{ $t('tel') }}(0065)98989098</div>
      </div>
      <div class="right">
        <!-- <div class="icon">
          <img :src="require('@/assets/imgs/footer_icon.png')" />
        </div> -->
        <div>Copyright © 2024 SINGAPORE BAOLU TECHNOLOGY PTE. LTD.</div>
        <div>All rights reserved.</div>
      </div>
    </div>
  </div>
</template>

<script setup></script>
<style scoped>
.footer {
  background: #000000;
}
.footer_context {
  width: 1200px;
  height: 100%;
  margin: auto;
  padding: 86px 0 117px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left,
.right {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  line-height: 12px;
}
.left > div + div {
  margin-top: 18px;
}
.border {
  width: 12px;
  margin-left: 9px;
}
.left > div {
  display: flex;
  align-items: center;
}
.icon {
  width: 123px;
  margin-bottom: 24px;
}
.right {
  display: flex;
  flex-direction: column;
  align-items: end;
}

.right > div + div {
  margin-top: 2px;
}
</style>
